
import { BaseNotification, NotificationCategory, NotificationPriority } from '@/types/notifications';
import { NotificationUtils } from './NotificationUtils';

export abstract class BaseNotificationManager {
  protected notifications: BaseNotification[] = [];
  private readonly storageKey: string;

  constructor(storageKey: string) {
    this.storageKey = storageKey;
    this.loadFromStorage();
  }

  protected loadFromStorage(): void {
    const saved = NotificationUtils.loadFromStorage(this.storageKey);
    if (saved) {
      this.notifications = saved;
    }
  }

  protected saveToStorage(): void {
    NotificationUtils.saveToStorage(this.storageKey, this.notifications);
  }

  protected createBaseNotification(
    title: string,
    message: string,
    category: NotificationCategory,
    priority: NotificationPriority
  ): BaseNotification {
    return {
      id: NotificationUtils.generateId(),
      title,
      message,
      timestamp: Date.now(),
      read: false,
      category,
      priority
    };
  }

  public getUnreadCount(): number {
    return this.notifications.filter(n => !n.read).length;
  }

  public markAsRead(id: string): boolean {
    const notification = this.notifications.find(n => n.id === id);
    if (notification) {
      notification.read = true;
      this.saveToStorage();
      return true;
    }
    return false;
  }

  public markAllAsRead(): void {
    this.notifications.forEach(n => n.read = true);
    this.saveToStorage();
  }

  public deleteNotification(id: string): boolean {
    const index = this.notifications.findIndex(n => n.id === id);
    if (index !== -1) {
      this.notifications.splice(index, 1);
      this.saveToStorage();
      return true;
    }
    return false;
  }

  public clearAll(): void {
    this.notifications = [];
    this.saveToStorage();
  }
}
